/**
 * Shows the user has set aside by hand.
 *
 * Local only, and deliberately so. Simkl has no concept of "I am not watching
 * this right now but do not remove it" — its statuses are watching, hold,
 * dropped, and using `hold` for this would change what the account says to
 * every other Simkl client the user has. This is a view of the queue, not a
 * fact about the library.
 */
import { META_STORE, withStore } from "@/store/db";

const ASIDE_KEY = "set-aside";

export async function readAside(): Promise<number[]> {
  try {
    const [stored] = await withStore<number[] | undefined>(
      META_STORE,
      "readonly",
      (store) => store.get(ASIDE_KEY) as IDBRequest<number[] | undefined>,
    );
    return stored ?? [];
  } catch {
    return [];
  }
}

export async function writeAside(ids: readonly number[]): Promise<void> {
  await withStore(META_STORE, "readwrite", (store) => store.put([...ids], ASIDE_KEY));
}
